<template>
    <el-card class="box-card">
        <div class="component-content">
            <section class="content">
                <el-dialog
                    title="信息更新结果"
                    :visible.sync="resultShow"
                    width="50%" lock-scroll
                    center
                >
                    <el-table :data="resultArray"
                              row-key="id + '_' + server_url"
                              stripe
                              style="width: 100%;"
                              :default-sort="{prop: 'id'}"
                    >
                        <el-table-column prop="server_name" label='服务器名' width="160" fixed></el-table-column>
                        <el-table-column prop="server_url" label='请求地址' width="500"></el-table-column>
                        <el-table-column prop="resStatus" label='响应结果' width="150"></el-table-column>
                    </el-table>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="resultShow = false">关闭</el-button>
                    </div>
                </el-dialog>
                <div>
                    <el-tabs v-model="activeName" @tab-click="handleClick">
                        <el-tab-pane name="second" label="活动模板">
                            <el-card>
                                <div slot="header" class="clearfix">
                                    <span>配置信息</span>
                                </div>
                                <el-table :data="activityTemplateConfigs"
                                          row-key="id"
                                          border
                                          stripe
                                          style="width: 100%;"
                                          :default-sort="{prop: 'id'}"
                                >
                                    <el-table-column prop="id" label='编号' width="180"></el-table-column>
                                    <el-table-column label='活动分类' width="100" >
                                        <template slot-scope="scope">
                                            <span  v-for="typeItem in activityTypeArray" :key="typeItem.id" v-if="scope.row.type == typeItem.id">{{typeItem.lang}}</span>
                                        </template>
                                    </el-table-column>

                                    <el-table-column prop="seq_no" label='排序' width="100" sortable></el-table-column>
                                    <el-table-column prop="open_lv" label='开放等级' width="80"></el-table-column>
                                    <el-table-column prop="expire_lv" label='失效等级' width="80"></el-table-column>
                                    <el-table-column prop="record" label='模板记录' width="280"></el-table-column>
                                    <el-table-column prop="style_version" label='模板版本' width="80"></el-table-column>
                                    <el-table-column prop="template" label='模板' width="230"></el-table-column>
                                    <el-table-column prop="channel_limit" label='渠道限制' width="100"></el-table-column>
                                </el-table>
                            </el-card>
                        </el-tab-pane>
                        <el-tab-pane name="first" label="活动信息">
                            <el-card>
                                <div slot="header" class="clearfix">
                                    <span>配置数据</span>
                                </div>
                                <el-form>
                                    <el-form-item>
                                        <el-button type="primary"  @click="activityDialogShow">添加活动</el-button>
                                    </el-form-item>
                                </el-form>
                                <el-table :data="activityConfigs"
                                          row-key="id"
                                          border
                                          stripe
                                          style="width: 100%;"
                                          :default-sort="{prop: 'id'}">
                                    <el-table-column prop="id" label='编号' width="100">
                                    </el-table-column>
                                    <el-table-column label='模板信息' width="260">
                                        <template slot-scope="scope">
                                            <span v-for="templateItem in activityTemplateConfigs" v-if="templateItem.id === scope.row.template_id">
                                                <{{scope.row.template_id}}> <{{templateItem.record}}>
                                            </span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label='开放的游戏服' width="120">
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.serverids == 0"> 全服开放</span>
                                            <span v-if="scope.row.serverids != 0"> {{ scope.row.serverids }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label='活动状态' width="100">
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.stime === -1">
                                                <span style="color: sandybrown;" v-if="scope.row.switch_flag == 0">临时关闭</span>
                                                <span style="color: green;" v-if="scope.row.switch_flag == 1">常驻</span>
                                            </span>
                                            <span v-if="scope.row.stime !== -1">
                                                <span style="color: sandybrown;" v-if="scope.row.switch_flag == 0">临时关闭</span>
                                                <span v-if="scope.row.switch_flag == 1">
                                                    <span v-if="(new Date().getTime()) < scope.row.stime">
                                                        未开放
                                                    </span>
                                                    <span style="color: gray;" v-if="(new Date().getTime()) >
                                                        scope.row.etime">已失效
                                                    </span>
                                                    <span style="color: green;" v-if="(new Date().getTime()) >= scope.row.stime && (new Date().getTime()) < scope.row.etime">
                                                        开放中
                                                    </span>
                                                </span>
                                            </span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label='活动开启时间' width="180">
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.stime === -1">
                                                长期开启
                                            </span>
                                            <span v-if="scope.row.stime !== -1">
                                                {{scope.row.startTime}}
                                            </span>
                                            <el-tooltip class="item" effect="dark" placement="top-start">
                                                <div slot="content">
                                                    到达活动开启时间时，活动开启<br/>
                                                </div>
                                                <i class="el-icon-question"></i>
                                            </el-tooltip>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label='活动结束时间' width="180">
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.stime === -1">
                                                长期开启
                                            </span>
                                            <span v-if="scope.row.stime !== -1">
                                                {{scope.row.closeTime}}
                                            </span>
                                            <el-tooltip class="item" effect="dark" placement="top-start">
                                                <div slot="content">
                                                    到达活动结束时间时，活动结束（活动界面不会关闭，方便部分活动查看历史记录和兑换奖励，但无法进行活动游玩）<br/>
                                                </div>
                                                <i class="el-icon-question"></i>
                                            </el-tooltip>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label='活动界面关闭时间' width="180" >
                                        <template slot-scope="scope">
                                             <span v-if="scope.row.stime === -1">
                                                长期开启
                                            </span>
                                            <span v-if="scope.row.stime !== -1">

                                                {{scope.row.endTime}}
                                            </span>
                                            <el-tooltip class="item" effect="dark" placement="top-start">
                                                <div slot="content">
                                                    到达活动界面关闭时间时，活动界面关闭<br/>
                                                </div>
                                                <i class="el-icon-question"></i>
                                            </el-tooltip>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="memo_backup" label='备注' width="180"></el-table-column>
                                    <el-table-column label='操作处理' width="350">
                                        <template slot-scope="scope">
                                             <span v-if="scope.row.stime === -1">
                                            <!--常驻-->
                                                 <el-button style="color: sandybrown;" type="text" v-if="scope.row.switch_flag == 1" @click="temporarilyClosedActivity(scope.row)">临时关闭</el-button>
                                                 <el-button type="text" v-if="scope.row.switch_flag == 0"  @click="recoverActivity(scope.row)">恢复活动</el-button>
                                            </span>
                                            <span v-if="scope.row.stime !== -1">
                                                <span v-if="(new Date().getTime()) > scope.row.etime">
                                                    <!--限时（失效的活动）-->
                                                    <el-button style="color: red;" type="text" v-if="scope.row.template_id !== 34" @click="delActivity(scope.row)">删除活动</el-button>
                                                    <el-button type="text" v-if="scope.row.template_id == 34" @click="editTimeActivity(scope.row)">编辑时间</el-button>
                                                </span>
                                                <span v-if="(new Date().getTime()) < scope.row.stime">
                                                    <!--限时（未开放）-->
                                                    <el-button style="color: sandybrown;" type="text" v-if="scope.row.switch_flag == 1"  @click="temporarilyClosedActivity(scope.row)">临时关闭</el-button>
                                                    <el-button type="text" v-if="scope.row.switch_flag == 0" @click="recoverActivity(scope.row)">恢复活动</el-button>
                                                    <el-button style="color: red;" type="text" v-if="scope.row.template_id !== 34"  @click="delActivity(scope.row)">删除活动</el-button>
                                                    <el-button type="text" v-if="scope.row.template_id == 34" @click="editTimeActivity(scope.row)">编辑时间</el-button>
                                                </span>
                                                <span v-if="(new Date().getTime()) >= scope.row.stime && (new Date().getTime()) < scope.row.etime">
                                                    <!--限时（开放中）-->
                                                    <el-button style="color: sandybrown;" type="text" v-if="scope.row.switch_flag == 1"  @click="temporarilyClosedActivity(scope.row)">临时关闭</el-button>
                                                    <el-button type="text" v-if="scope.row.switch_flag == 0" @click="recoverActivity(scope.row)">恢复活动</el-button>
                                                    <el-button style="color: red;" type="text" @click="closedActivity(scope.row)">结束活动</el-button>
                                                </span>
                                            </span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </el-card>

                            <el-dialog title='编辑创友招募时间' :visible.sync="activityTimeShowTag" width="80%" lock-scroll center>
                                <div>
                                    <el-form :model="timeEditForm" label-width="180px" label-suffix=":">
                                        <el-form-item label="当前时间">
                                            <span> {{timeEditForm.startTime}} ~ {{timeEditForm.endTime}} </span>
                                        </el-form-item>
                                        <el-form-item label="活动开启时间">
                                            <el-date-picker v-model="timeEditForm.startDateTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :default-time="'00:00:00'">
                                            </el-date-picker>
                                            <div style="color: red">到达活动开启时间时，活动开启</div>
                                        </el-form-item>
                                        <el-form-item label="活动结束时间">
                                            <el-date-picker v-model="timeEditForm.closeDateTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :default-time="'23:59:59'">
                                            </el-date-picker>
                                            <div style="color: red">到达活动结束时间时，活动结束（活动界面不会关闭，方便部分活动查看历史记录和兑换奖励，但无法进行活动游玩）</div>
                                        </el-form-item>
                                        <el-form-item label="活动界面关闭时间">
                                            <div>{{timeEditForm.closeDateTime}}</div>
                                            <div style="color: red">到达活动界面关闭时间时，活动界面关闭</div>
                                        </el-form-item>
                                    </el-form>
                                </div>

                                <div slot="footer" class="dialog-footer">
                                    <el-button @click="activityTimeShowTag = false">取消</el-button>
                                    <el-button type="primary" @click="confirmTimeActivity">确认</el-button>
                                </div>
                            </el-dialog>

                            <el-dialog title='添加活动' :visible.sync="addActivityShowTag" width="80%" lock-scroll center>
                                <div>
                                    <el-form :model="activityBuildForm" label-width="180px" label-suffix=":">
                                        <el-form-item label="模板信息">
                                            <el-select v-model="activityBuildForm.templateId" @change="activityChange">
                                                <el-option v-for="item in activityTemplateConfigs" :key="item.id"
                                                           :label="'<' +item.id + '><' + item.record + '>'"
                                                           :value="item.id"
                                                           :disabled="item.select_tag == 0">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="开放的游戏服">
                                            <el-switch
                                                v-model="activityBuildForm.selectAllServerTag"
                                                active-color="#13ce66"
                                                inactive-color="#ff4949"
                                                active-text="全服"
                                                inactive-text="选服"
                                                :active-value="true"
                                                :inactive-value="false">
                                            </el-switch>
                                        </el-form-item>
                                        <el-form-item label="游戏服信息" v-if="!activityBuildForm.selectAllServerTag">
                                            <el-select v-model="activityBuildForm.serverIds" multiple>
                                                <el-option v-for="item in serverGameList" :key="item.id"
                                                           :label="item.server_number + '(' + item.server_name + ')'"
                                                           :value="item.server_number">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="临时状态">
                                            <el-switch
                                                v-model="activityBuildForm.switchFlag"
                                                active-color="#13ce66"
                                                inactive-color="#ff4949"
                                                active-text="正常开放"
                                                inactive-text="临时关闭"
                                                :active-value="1"
                                                :inactive-value="0">
                                            </el-switch>
                                            <div style="color: red">临时关闭：关闭时表示活动在生效时间也处于关闭状态</div>
                                        </el-form-item>
                                        <el-form-item label="备注信息">
                                            <el-input v-model="activityBuildForm.memoBackup"></el-input>
                                            <div style="color: red">策划自行记录，前端不展示</div>
                                        </el-form-item>
                                        <el-form-item label="活动开启时间">
                                            <el-date-picker v-model="activityBuildForm.startDateTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :default-time="'00:00:00'">
                                            </el-date-picker>
                                            <div style="color: red">到达活动开启时间时，活动开启</div>
                                        </el-form-item>
                                        <el-form-item label="活动结束时间">
                                            <el-date-picker v-model="activityBuildForm.closeDateTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :default-time="'23:59:59'">
                                            </el-date-picker>
                                            <div style="color: red">到达活动结束时间时，活动结束（活动界面不会关闭，方便部分活动查看历史记录和兑换奖励，但无法进行活动游玩）</div>
                                        </el-form-item>
                                        <el-form-item label="活动界面关闭时间">
                                            <el-date-picker v-if="timeUnlockTemplateArray.indexOf(activityBuildForm.templateId) !== -1"
                                                            v-model="activityBuildForm.endDateTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" :default-time="'23:59:59'">
                                            </el-date-picker>
                                            <div v-if="timeUnlockTemplateArray.indexOf(activityBuildForm.templateId) === -1">{{activityBuildForm.closeDateTime}}</div>
                                            <div style="color: red">Tips1:到达活动界面关闭时间时，活动界面关闭</div>
                                            <div style="color: red" v-if="timeUnlockTemplateArray.indexOf(activityBuildForm.templateId) === -1">
                                                Tips2:该活动界面关闭时间必须等于活动结束时间</div>
                                        </el-form-item>
                                    </el-form>
                                </div>

                                <div slot="footer" class="dialog-footer">
                                    <el-button @click="addActivityShowTag = false">取消</el-button>
                                    <el-button type="primary" @click="confirmAddActivity">确认</el-button>
                                </div>
                            </el-dialog>
                        </el-tab-pane>

                        <el-tab-pane name="third" label="活动日历"></el-tab-pane>
                    </el-tabs>
                </div>
            </section>
        </div>
    </el-card>
</template>

<script>
   import {
       mapState
   } from 'vuex';
   import confApi from '../../service/conf_api'
   import activityApi from '../../service/activity_api'
   import worldApi from '../../service/world_api'
   import gameApi from '../../service/game_api'
   import loginApi from '../../service/login_api'
   import actionConfirm from '../../mixins/action_confirm'
   import Utils from '../../lib/utils'
   import commonApi from "../../service/common_api";
   import activity_type from '../../data/config/activity_type.json';
   import warApi from "../../service/war_api";

    export default {
        name: "activityConfig",
        data() {
            return {
                title: this.$route.meta.title,
                calendarShow: false,
                activityTypeArray: activity_type,
                topTemplate:['VERSION_ACTIVITY','WEEKEND_ACTIVITY'],
                timeUnlockTemplate:['ONE_COIN_PASSED','GENESIS_QUIZ','BEST_THREE'],//一创到底,创世竞猜，三阵入局
                timeUnlockTemplateArray:[],
                templateRelation:{},
                activeName: 'first',
                activityConfigs:[],
                activityTemplateConfigs:[],
                resultShow:false,
                resultArray:[],
                loginInfoGame:[],
                loginInfoWorld:[],

                addActivityShowTag: false,
                activityBuildForm:{},

                activityTimeShowTag:false,
                timeEditForm: {},
            }
        },
        computed: {
            ...mapState({
                token: state => state.user.userInfo.loginToken,
                serverGameList: state => state.server.serverGameList,
                serverWorldList: state => state.server.serverWorldList,
            }),
        },
        mixins: [ actionConfirm],
        mounted() {
            this.loadActivityInfo();
        },
        methods: {
            handleClick(tab, event) {
                if (tab == 'fiirst'){
                    this.loadActivityInfo();
                }
            },
            loadActivityInfo() {
                let self = this;
                commonApi.getConfs({
                    tables: 'activity_config,activity_template_config,login_info_game,login_info_world'
                }).then(res => {
                    self.activityTemplateConfigs = [];
                    self.timeUnlockTemplateArray = [];
                    res.activity_template_config.forEach(templateConfig=> {
                        if (templateConfig.type !== 0) {
                            self.activityTemplateConfigs.push(templateConfig);
                        }

                        let template = templateConfig.template;
                        if (self.topTemplate.indexOf(template) !== -1){
                            let templateArray = templateConfig.param_common.split(",");
                            templateArray.forEach(subTemplate => {
                                self.templateRelation[subTemplate] = template;
                            })
                        }

                        if (self.timeUnlockTemplate.indexOf(template) !== -1){
                            self.timeUnlockTemplateArray.push(templateConfig.id);
                        }
                    })

                    self.activityConfigs = [];
                    self.activityConfigs = res.activity_config;
                    self.activityConfigs.forEach(item => {
                        item.startTime = (item.stime!==-1)?Utils.formatDate(new Date(item.stime)):item.stime;
                        item.endTime = (item.etime!==-1)?Utils.formatDate(new Date(item.etime)):item.etime;
                        item.closeTime = (item.close_time!==-1)?Utils.formatDate(new Date(item.close_time)):item.close_time;

                        this.activityTemplateConfigs.forEach(activityTemplateConfig =>{
                            if (activityTemplateConfig.id === item.template_id){
                                item.activityTemplateConfig = activityTemplateConfig;
                            }
                        })
                    })
                    let sourceGameInfo = res.login_info_game;
                    this.loginInfoGame = [];
                    let subGameInfo = [];
                    for (let tmpItem of sourceGameInfo) {
                        if ('0' === tmpItem.combine_server_number) {
                            //0为主服
                            tmpItem.children = [];
                            this.loginInfoGame.push(tmpItem);
                        } else {
                            subGameInfo.push(tmpItem);
                        }
                    }

                    for (let tmpItem of subGameInfo) {
                        this.loginInfoGame.forEach(mainGameServer => {
                            if (tmpItem.combine_server_number === mainGameServer.server_number) {
                                mainGameServer.children.push(tmpItem);
                            }
                        })
                    }

                    let sourceWorldInfo = res.login_info_world;
                    this.loginInfoWorld = [];
                    let subWorldInfo = [];
                    for (let tmpItem of sourceWorldInfo) {
                        tmpItem.server_maintenance = -1;
                        if ('0' === tmpItem.combine_server_number) {
                            //0为主服
                            tmpItem.children = [];
                            this.loginInfoWorld.push(tmpItem);
                        } else {
                            subWorldInfo.push(tmpItem);
                        }
                    }

                    for (let tmpItem of subWorldInfo) {
                        this.loginInfoWorld.forEach(mainServer => {
                            if (tmpItem.combine_server_number === mainServer.server_number) {
                                mainServer.children.push(tmpItem);
                            }
                        })
                    }
                })
            },

            activityDialogShow() {
                this.addActivityShowTag = true;
                this.activityBuildForm ={
                    templateId:0,
                    selectAllServerTag:true,
                    serverIds:'0',
                    switchFlag:1,
                    memoBackup:'',
                    startDateTime:'',
                    endDateTime:'',
                    closeDateTime:'',
                };
            },

            //添加活动
            confirmAddActivity() {
                let self = this;
                let buildForm = self.activityBuildForm;
                let stime = buildForm.startDateTime;
                let etime = buildForm.endDateTime;
                let closeTime = buildForm.closeDateTime;
                if (self.timeUnlockTemplateArray.indexOf(buildForm.templateId) === -1){
                    //不在自由调整时间的范围
                    etime = closeTime;
                }
                buildForm.stimeDate = stime;
                buildForm.etimeDate = etime;
                buildForm.closetimeDate = closeTime;

                //活动冲突判断
                let start1 = new Date(stime).getTime();
                let end1 = new Date(etime).getTime();
                let close1 = new Date(closeTime).getTime();
                if (close1 > end1){
                    this.$message({
                        type: 'error',
                        message: '活动结束时间 不能超过 活动界面关闭时间'
                    });
                    return;
                }

                if (self.timeUnlockTemplateArray.indexOf(buildForm.templateId) === -1 && etime !== closeTime){
                    this.$message({
                        type: 'error',
                        message: '此模板活动结束时间 与 活动界面关闭时间 需要一致。'
                    });
                    return;
                }

                let serverName = '全服';
                if (buildForm.selectAllServerTag) {
                    buildForm.serverids = '0';
                } else {
                    buildForm.serverids = buildForm.serverIds.join(',');
                    serverName = buildForm.serverids;
                }

                let currentTemplateConfig;
                let fatherTemplateConfigs = [];
                this.activityTemplateConfigs.forEach(activityTemplateConfig =>{
                    if (activityTemplateConfig.id == buildForm.templateId){
                        currentTemplateConfig = activityTemplateConfig;
                    }
                })

                let fatherTemplate = self.templateRelation[currentTemplateConfig.template];
                if (fatherTemplate !== undefined){
                    this.activityTemplateConfigs.forEach(activityTemplateConfig =>{
                        if (activityTemplateConfig.template == fatherTemplate){
                            fatherTemplateConfigs.push(activityTemplateConfig);
                        }
                    })
                }

                let conflicts = [];
                let fatherOpenCheck = [];
                this.activityConfigs.forEach(activityConfig =>{
                    let start2 = activityConfig.stime;
                    let end2 = activityConfig.etime;

                    //判断活动时间是否有重叠
                    if (activityConfig.stime === -1 ||
                        (start1 <= end2 && end1 >= start2) ||
                        (start2 <= end1 && end2 >= start1)
                    ){
                        if (activityConfig.activityTemplateConfig.template === currentTemplateConfig.template){
                            conflicts.push(activityConfig.id + '<' + activityConfig.template_id + '><' + activityConfig.activityTemplateConfig.record + '>');
                        }
                    }

                    if (fatherTemplate !== undefined && activityConfig.activityTemplateConfig.template === fatherTemplate){
                        if (start2 <= start1 && end1 <= end2){
                            fatherOpenCheck.push(activityConfig.id + '<' + activityConfig.template_id + '><' + activityConfig.activityTemplateConfig.record + '>');
                        }
                    }
                })

                if (fatherTemplate !== undefined && fatherOpenCheck.length <= 0){
                    let tipsArray =[];
                    fatherTemplateConfigs.forEach(fatherTemplateConfig=>{
                        tipsArray.push('<' + fatherTemplateConfig.id + '><' + fatherTemplateConfig.record + '>');
                    })
                    this.$message({
                        type: 'error',
                        message: '需要先开启此活动的父活动【'+tipsArray.join(" ")+'】，且子活动的时间范围要小于等于父活动'
                    });
                    return;
                }


                if (conflicts.length > 0){
                    let conflictRecord = conflicts.join(";");
                    this.$message({
                        type: 'error',
                        message: '与生效中的活动有重叠。【' + conflictRecord + '】'
                    });
                    return;
                }

                this.$confirm("此操作会重载的游戏服列表【"+ serverName +"】（玩家无感）", '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    //当前时间可开启绝版UP活动，当前活动无法开启
                    console.log(buildForm);
                    activityApi.saveActivity({
                        token: this.token,
                        createForm: {
                            templateId: buildForm.templateId,
                            serverids: buildForm.serverids,
                            switchFlag: buildForm.switchFlag,
                            memoBackup: buildForm.memoBackup,
                            stimeDate: buildForm.stimeDate,
                            etimeDate: buildForm.etimeDate,
                            closetimeDate: buildForm.closetimeDate,
                        }
                    }).then(res => {
                        self.addActivityShowTag = false;
                        this.$message({
                            type: 'success',
                            message: '创建成功'
                        })
                        self.loadActivityInfo();
                        self.reloadAxiosAll(buildForm.serverids);
                    })
                })
            },

            // 重载游戏服
            reloadAxiosAll(serverids) {
                let self = this;
                self.resultShow = true;
                self.resultArray = [];
                let gameServerArray = serverids.split(",");

                let relationWorldId = [];
                self.loginInfoGame.forEach(loginInfoGameItem =>{
                    if (serverids == '0'){
                        self.reloadGameItem(loginInfoGameItem);
                    }else{
                        if (gameServerArray.indexOf(loginInfoGameItem.server_number) != -1){
                            self.reloadGameItem(loginInfoGameItem);
                            relationWorldId.push(loginInfoGameItem.world_id);
                        }
                    }
                })

                self.loginInfoWorld.forEach(loginInfoWorldItem =>{
                    if (serverids == '0'){
                        self.reloadWorldItem(loginInfoWorldItem);
                    }else{
                        if (relationWorldId.indexOf(loginInfoWorldItem.id) != -1){
                            self.reloadWorldItem(loginInfoWorldItem);
                        }
                    }
                })
            },

            /**
             * 重载单个游戏服
             * @param reloadGameInfo
             */
            reloadGameItem(reloadGameInfo){
                let self = this;
                let balanceIps = reloadGameInfo.inner_urls.split(';');
                balanceIps.forEach(item => {
                    if ('' != item) {
                        self.resultArray.push({
                            server_url: item,
                            server_name: reloadGameInfo.server_name,
                            resStatus: '0'
                        });
                        let reloadForm = {
                            uri: item,
                            type: 'game',
                            className: 'ActivityConfig',
                            serverName: reloadGameInfo.server_name
                        }
                        gameApi.gameReloadConfig({
                            token: self.token,
                            reloadForm: reloadForm
                        }).then(res => {
                            self.resultArray.forEach(resultItem => {
                                if (resultItem.server_url == reloadForm.uri) {
                                    resultItem.resStatus = res.resStatus
                                }
                            })
                        })
                    }
                })
            },

            /**
             * 重载单个战区
             * @param reloadWorldInfo
             */
            reloadWorldItem(reloadWorldInfo){
                let self = this;
                let balanceIps = reloadWorldInfo.inner_urls.split(';');
                balanceIps.forEach(item => {
                    if ('' != item) {
                        self.resultArray.push({
                            server_url: item,
                            server_name: reloadWorldInfo.server_name,
                            resStatus: '0'
                        });
                        let reloadForm = {
                            worldUri: item,
                            type: 'world',
                            className: 'ActivityConfig',
                            serverName: reloadWorldInfo.server_name
                        }
                        worldApi.worldReloadConfig({
                            token: self.token,
                            reloadForm: reloadForm
                        }).then(res => {
                            self.resultArray.forEach(resultItem => {
                                if (resultItem.server_url == reloadForm.worldUri) {
                                    resultItem.resStatus = res.resStatus
                                }
                            })
                        })
                    }
                })
            },

            /**
             * 1临时关闭
             * @param rowData
             */
            temporarilyClosedActivity(rowData){
                let self = this;
                this.$confirm("此操作会重载的游戏服列表（玩家无感）", '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    activityApi.temporarilyClosedActivity({
                        token: self.token,
                        temporarilyClosedForm:{
                            id:rowData.id
                        }
                    }).then(res => {
                        this.$message({
                            type: 'success',
                            message: '活动临时关闭'
                        })
                        self.loadActivityInfo();
                        self.reloadAxiosAll(rowData.serverids);
                    })
                });

            },
            /**
             * 2恢复活动
             * @param rowData
             */
            recoverActivity(rowData){
                let self = this;
                this.$confirm("此操作会重载的游戏服列表（玩家无感）", '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    activityApi.recoverActivity({
                        token: self.token,
                        recoverForm:{
                            id:rowData.id
                        }
                    }).then(res => {
                        this.$message({
                            type: 'success',
                            message: '活动恢复'
                        })
                        self.loadActivityInfo();
                        self.reloadAxiosAll(rowData.serverids);
                    })
                });

            },
            /**
             * 3结束活动
             * @param rowData
             */
            closedActivity(rowData){
                let self = this;
                this.$confirm("此操作会重载的游戏服列表（玩家无感）", '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    activityApi.closedActivity({
                        token: self.token,
                        closedForm:{
                            id:rowData.id
                        }
                    }).then(res => {
                        this.$message({
                            type: 'success',
                            message: '活动已结束'
                        })
                        self.loadActivityInfo();
                        self.reloadAxiosAll(rowData.serverids);
                    })
                });

            },
            /**
             * 4删除活动
             * @param rowData
             */
            delActivity(rowData){
                let self = this;
                this.$confirm("此操作会删除活动配置并重载的游戏服列表（玩家无感）", '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    activityApi.delActivity({
                        token: self.token,
                        delForm: {
                            id:rowData.id
                        }
                    }).then(res => {
                        this.$message({
                            type: 'success',
                            message: '活动已删除'
                        })
                        self.loadActivityInfo();
                        self.reloadAxiosAll(rowData.serverids);
                    })
                })

            },

            editTimeActivity(rowData){
                this.activityTimeShowTag = true;
                this.timeEditForm = {
                    rowData:rowData,
                    startTime:rowData.startTime,
                    endTime:rowData.endTime,
                    closeTime:rowData.closeTime,
                    startDateTime:'',
                    endDateTime:'',
                    closeDateTime:''
                }
            },
            confirmTimeActivity(){
                let self = this;
                let stime = self.timeEditForm.startDateTime;
                let etime = self.timeEditForm.closeDateTime;
                let closeTime = self.timeEditForm.closeDateTime;

                this.$confirm("此操作会重载的游戏服列表（玩家无感）", '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    activityApi.timeActivityRefresh({
                        token: self.token,
                        refreshForm:{
                            id:self.timeEditForm.rowData.id,
                            stimeDate:stime,
                            etimeDate:etime,
                            closetimeDate:closeTime
                        }
                    }).then(res => {
                        this.$message({
                            type: 'success',
                            message: '创友招募时间已更新'
                        })
                        self.loadActivityInfo();
                        self.reloadAxiosAll(self.rowData.serverids);
                    })
                });
            },
            activityChange(){
                let self = this;
                let templateId = self.activityBuildForm.templateId >>0;
                let targetName = '';
                self.activityTemplateConfigs.forEach(item => {
                    if (item.id === templateId) {
                        targetName = item.record;
                    }
                })
                self.activityBuildForm.memoBackup = targetName;
            }

        },
    };
</script>

<style lang="less">
    .config_label {
        font-size: 18px;
    }

    .btn-group {
        display: flex;
    }
     .is-selected {
        color: #1989FA;
      }

    .el-calendar-table .el-calendar-day {
        height: auto !important;
    }
</style>



// WEBPACK FOOTER //
// src/views/activity_gift/activity_editor.vue